var  Marionette = require('marionette'),
    $ = require('jquery'),
    _ = require('underscore'),
    ShapeView = require('./shape'),
    HoverEditDialog = require('./hoverEditDialog');


/**
 * Shape View With a toggleable Edit Btn In its selectSet that hides/shows a HoverEditDialog that's a child of this view.
 * The HoverEditDialog wraps a view to show ( now dialogConstructor )
 */

module.exports = ShapeView.extend({

    initialize: function(options) {

        ShapeView.prototype.initialize.apply(this, arguments);

        this.listenTo( this.channel, 'canvas:closeAllDialogs', this._removeDialog );

        this.dialogView = null;

        /* req'd */
        _.extend( this, _.pick( options, 'dialog', 'dialogConstructor','dialogBtnConstructor','dialogOptions') );
        _.bindAll( this, '_closeDialog', '_showDialog' ); /* jqEvent callbacks from body / edit btn view -- bind to here for easier unbinding */

    },


    /**
     * A continuation of base selection.
     * Must catch at level of inheritance desired -- can't call _super on
     */
    onAfterButtonSetCreation: function() {
        ShapeView.prototype.onAfterButtonSetCreation.apply(this, arguments);
        this.btnSet.addBtn('edit', this.dialogBtnConstructor);
        this._toggleEditBtnHandle(1);
    },

    //( Opposite of onAfterButtonSetCreation )
    _destroySelectSet: function() {

        ShapeView.prototype._destroySelectSet.call(this, arguments);
        this._closeDialog({
            fromDestroySelectSet: true
        });

    },

    /**
     * Note: don't want to use the dropdown plugin
     * ability to have this and other dropdowns / views open (note view).
     * Have separate 'body' click event to handle separately -- a number of its triggers on the canvas/shapes will prevent propagation
     * (Separate Btn and Body Handlers B/C on start, only allow open via button (not, body click)
     */
    _toggleEditBtnHandle: function(turnOn) {

        this._getEditBtn()
            .off('click', this['_' + (turnOn ? 'close' : 'show')  + 'Dialog'])
            .on ('click', this['_' + (turnOn ? 'show'  : 'close') + 'Dialog']);

    },
    _showDialog: function(e) {

        if (e) {
            e.stopPropagation(); // don't allow to hit body
        }

        $('body')
            .off('click', this._showDialog)
            .on('click',  this._closeDialog);

        this._toggleEditBtnHandle(0);
        this.trigger( 'shapeWithDialog:beforeOpen' );

        this.shapeModel.trigger('canvas:zoneDialogOpened'); // ( now sole purpose is closed corresponding F&R dialog )

        this.dialogView = this._createDialog();
        this.dialogView.triggerMethod('show'); // mimic Marionette onShow used for Regions ( here it would be in DOM )

    },

    /**
     * Remove the dialog under the following conditions.
     * Inline dropdowns, allow clicks on the body.
     * Note: the propagation of the event is often stopped from mouse events on the canvas/canvas shapes.
     * Mouse events can also come from moving/resizing the shape on the canvas.
     */
    _closeDialog: function(e) {

        // Always turn on click -- for button, may have already been deleted from destroy select set
        $('body').off('click', this._closeDialog);

        // From click (this check fixes issue of clicking another shape ---
        // that will have already destroyed the select set
        if (e && !e.fromDestroySelectSet) {

            e.stopPropagation();

            // Instead of messing with complex drawing event propagation: disallow those starting from certain node types
            // Allow to Resize, move, etc ... without closing the dialog
            // I is scale button, SPAN toggle FS -- only do if SVG? -- 'SHAPE' is IE8 ???
            // DVBC-1824: is this still desired? -- dialog not closed for signature with click on another shape ...
            var node = e.target.nodeName.toUpperCase(); // (allow edit btn)
            if ( _.contains(['PATH', 'CIRCLE', 'DIV', 'INPUT', 'I', 'SPAN', 'SHAPE'], node) ) {
                return;
            }
            this._toggleEditBtnHandle(1); // btn set should exist
        }

        this._removeDialog();

    },

    /* Create, render ,and append to DOM */
    _createDialog: function() {

        var $wr = $(this.channel.request('viewerContainer')), /* don't cache the dom reference */
            dialog = new HoverEditDialog({

                parent: this,
                $opener: $(this.btnSet.getView('edit').getTransparentPathEl()),
                dialogConstructor: this.dialogConstructor,
                dialogOptions: this.dialogOptions

            }).render(); // render is like 'start now

        $wr.append( dialog.$el );

        return dialog;
    },

    /* remove and turn off the body handler */
    _removeDialog: function() {

        // Only do if the dialog was actually created ( this could be called from elsewhere, eg deleteShape without dialog )
        if ( this.dialogView ) {

            this.trigger( 'shapeWithDialog:beforeClose' );
            this.dialogView.destroy();
            this.dialogView = null; // ( also a flag that it was opened )
        }

    },
    _getEditBtn: function() {
        return $(this.btnSet.getView('edit').getTransparentPathEl());
    }



});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/shapeWithDialog.js
 ** module id = 212
 ** module chunks = 0
 **/